import { Controller } from '@hotwired/stimulus';

const THIRTY_DAYS = 60 * 60 * 24 * 30;

export default class extends Controller {
  static values = { id: Number };

  close() {
    document.cookie = `alert_${this.idValue}_closed=true; path=/; max-age=${THIRTY_DAYS}`;
    this.element.remove();
  }
}
